import { Divider, Stack } from '@mui/material'
import Header from './Header'

export default function GeneralSettings() {
    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <Header />
            <Divider />
        </Stack>
    )
}
